import { render, staticRenderFns } from "./article17.vue?vue&type=template&id=aa29a9ac"
import script from "./article17.vue?vue&type=script&lang=js"
export * from "./article17.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports